import { Metrics } from 'components/insights/constants';
import AnalyticsResponseRollupCollection from 'components/insights/query/AnalyticsResponseRollupCollection';

import { formatResponseTime } from '../constants';

import { readGrandTotal, readGrandTotalOrZero, readReferralRate } from './rollupHelpers';
import { RateTile, StatTile, TilesGrid, Value } from './statTiles';

type Props = {
  loading: boolean;
  rollups: AnalyticsResponseRollupCollection;
};

export default function SummaryDetailHeader({ loading, rollups }: Props) {
  const totalReferrals = readGrandTotalOrZero(rollups, Metrics.REVIEW_ID_COUNT);
  const acceptance = readReferralRate(rollups, Metrics.ACCEPTANCE_RATE);
  const denial = readReferralRate(rollups, Metrics.DENIAL_RATE);
  const avgResponseTime = readGrandTotal(rollups, Metrics.RESPONSE_TIME_SECONDS_AVERAGE);

  return (
    <TilesGrid $columns={4}>
      <StatTile label='Referrals Received'>
        <Value>{loading ? '—' : totalReferrals.toLocaleString()}</Value>
      </StatTile>
      <RateTile
        label='Acceptance Rate'
        tone='green'
        loading={loading}
        rate={acceptance.rate}
        numerator={acceptance.count}
        denominator={acceptance.total}
      />
      <RateTile
        label='Denial Rate'
        tone='red'
        loading={loading}
        rate={denial.rate}
        numerator={denial.count}
        denominator={denial.total}
      />
      <StatTile label='Avg. Response Time'>
        <Value>{loading ? '—' : formatResponseTime(avgResponseTime)}</Value>
      </StatTile>
    </TilesGrid>
  );
}
